<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import 'leaflet.markercluster';
export default {
  name: 'PartnerZone',
  components: {},

  props : {
    partner:{
          type:Object,
          default: () => null,

    }
  },

  data() {
    return {

      defaultIcon: L.icon({
        iconUrl: markerIcon,
        iconRetinaUrl: markerIconRetina,
        shadowUrl: markerShadow,
        iconSize: [20, 31], 
        iconAnchor: [12, 41], 
        popupAnchor: [1, -34], 
        shadowSize: [10, 10],
      }),

      filteredPharmaIcon: L.icon({
        iconUrl: require("@/assets/icons/pharmaMarker.png"),
        shadowUrl: markerShadow,
        iconSize: [20, 31], 
        iconAnchor: [12, 41], 
        popupAnchor: [1, -34], 
        shadowSize: [10, 10],  
      }),

    };
  },

  mounted() {
    this.initializeMap();
  },


  methods: {
    initializeMap() {

        this.map = L.map('mi_mapa_pzc').setView([this.partner.latitude, this.partner.longitude], 16);

        const osmLayer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 20,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        });

        osmLayer.addTo(this.map);

        this.addSingleMarker();

        setTimeout(() => { this.map.invalidateSize();}, 100);
    },

    addSingleMarker() {
        if (this.partner && this.partner.latitude && this.partner.longitude) {
            let icon;
            if (this.partner.sector === "Pharmacie") {
                icon = this.filteredPharmaIcon;
            } else {
                icon = this.defaultIcon;
            }

            const partnerMarker = L.marker([this.partner.latitude , this.partner.longitude], { icon: icon })
                .bindPopup(this.partner.companyName);

            partnerMarker.addTo(this.map);
        }
    }
  }
};
</script>


<template>
  <div  id="mi_mapa_pzc" ></div>
</template>


<style>
#mi_mapa_pzc {
  width: 100%;
  height: 400px;
  min-height: 350px;
  background-color: #f0f0f0;

  border: 1px solid rgb(221, 221, 221);
  border-radius: 4px;

  /*box-shadow: 0 12px 25px rgba(0, 0, 0, 0.3);*/

  transition: all 0.3s ease-in-out;
  position: relative;
}

</style>